import { ErrorSidePanel } from '@/components/errors';
import { useInvalidateSessions } from '../../-hooks/invalidate-sessions.hook';
import { ModuleName, Screen, type SkinPageConfig, templates } from '@nosinovacao/nosid-mfe-common';
import { createFileRoute } from '@tanstack/react-router';
import { type ActiveSessionsProps } from './-model/props';
import { ActiveSessionsLight } from './-skins';

export const Route = createFileRoute('/(security)/security/_sheet/active-sessions/')({
  component: RouteComponent,
  errorComponent: ErrorSidePanel,
  staticData: {
    module: ModuleName.Security,
    screen: Screen.AccountActivity,
  },
});

function RouteComponent() {
  const navigate = Route.useNavigate();
  const { mutate: invalidateSessions, isPending } = useInvalidateSessions();

  const props: ActiveSessionsProps = {
    onCancel: () => void navigate({ to: '/security' }),
    onConfirm: () => invalidateSessions(),
    isLoading: isPending,
  };

  return templates.getSkinSelector(skinConfig(props));
}

function skinConfig(props: ActiveSessionsProps): SkinPageConfig {
  return {
    skins: [],
    defaultValue: <ActiveSessionsLight {...props} />,
  };
}
